var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.882324 30.1176C0.882324 22.5979 6.99233 16.502 14.5294 16.502C22.0665 16.502 28.1764 22.5979 28.1764 30.1176H0.882324ZM14.5294 12.6118C17.7595 12.6118 20.3781 9.99921 20.3781 6.77647C20.3781 3.55374 17.7595 0.941177 14.5294 0.941177C11.2992 0.941177 8.68064 3.55374 8.68064 6.77647C8.68064 9.99921 11.2992 12.6118 14.5294 12.6118Z",
    fill: "#002366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon40);
export default __webpack_public_path__ + "static/media/user-icon(40.b036d55ad30c8d7c897f9746238ece6d.svg";
export { ForwardRef as ReactComponent };